<div class="content-wrapper">
    <div class="content-body">
        <section id="package">
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Direct Referrals</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="username"
                                           placeholder="Username">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="package_id">
                                        <option value="">Choose Package</option>
                                        <option [value]="package.id" *ngFor="let package of packages">
                                            {{package?.name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="filterForm">
                        <div class="row">
                            <div class="col-md-9 col-lg-9 col-sm-9 col-xs-12"></div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="session_id">
                                        <option [value]="session.id" *ngFor="let session of sessions">
                                            {{session?.name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3" *ngIf="myMembers && myMembers.length > 0; else noDataToShow">
                <div class="col-12">
                    <div class="card" *ngFor="let myMember of myMembers; let i = index">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_20 font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</span>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer">{{myMember?.user?.name}} ({{myMember?.user?.username}}) ({{myMember?.user?.member_id}})</span>
                                    <br>
                                    <small class="text-italic">Name(Username)(MemberId)</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer">{{myMember?.alignment}}</span>
                                    <br>
                                    <small class="text-italic">Alignment</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer" *ngIf="myMember && myMember['package'] && myMember['package']['name']">
                                        {{myMember?.package?.name}}
                                    </span>
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer" *ngIf="!myMember || !myMember['package'] || !myMember['package']['name']">
                                        FREE
                                    </span>
                                    <br>
                                    <small class="text-italic">Package</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15" *ngIf="myMember && myMember['joining_date']">
                                        {{myMember?.joining_date}}
                                    </span>
                                    <span class="font-weight-bold text-italic f_15" *ngIf="!myMember || !myMember['joining_date']">
                                        -
                                    </span>
                                    <br>
                                    <small class="text-italic">Joining Date Time</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">1</span>
                                    <br>
                                    <small class="text-italic">Level</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-user fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No members to show
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
